import { processSteps } from "@/content/siteContent";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export default function Process() {
  return (
    <section className="bg-ink py-24 md:py-32" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading
          chapter={processSteps.chapter}
          microtitle={processSteps.microtitle}
          titleA={processSteps.titleA}
          titleB={processSteps.titleB}
        />

        <div className="relative grid gap-10 md:grid-cols-4 md:gap-6">
          <div className="absolute left-0 right-0 top-9 hidden border-t border-dashed border-metal md:block" />
          {processSteps.steps.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.12}>
              <div className="relative" data-testid={`process-step-${step.num}`}>
                <div className="relative z-10 mb-6 flex items-center gap-4">
                  <span
                    className="flex h-[72px] w-[72px] items-center justify-center rounded-2xl border border-metal bg-graphite font-display text-2xl font-extrabold text-brand"
                    style={{ boxShadow: "inset 0 0 0 1px rgba(245,176,0,0.2), var(--shadow-industrial)" }}
                  >
                    {step.num}
                  </span>
                  <span className="h-px flex-1 bg-metal md:hidden" />
                </div>
                <h3 className="font-display text-base font-extrabold tracking-[0.14em] text-paper">{step.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-mist">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
